import * as React from "react";
import { AlertCircle } from "react-feather";
import { ViewModal } from "../modals/viewModal";
import { formatStrings } from "../../utils/time";
import { Table } from "../../newcomponents/table/table";
import { DateStringColumn } from "../../newcomponents/table/columns/generic/dateString";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { Kind } from "../../schema/types/base";
import { Button } from "antd";

interface Props {
  kind: Kind;
  eventlogs: any[];
  isLoading: boolean;
  isFetching: boolean;
  fetchEventlogs: any;
  nextLink: string | undefined;
}
export const Events: React.FC<Props> = ({ kind, eventlogs, isLoading, isFetching, fetchEventlogs, nextLink }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [event, setEvent] = React.useState({});

  return (
    <>
      <Table<any>
        title={"Events"}
        data={eventlogs}
        tableId={`${kind}-eventlogs-update-2`}
        headerRenderer={() => {
          return (
            <>
              <TableHeaderRefreshButton onClick={() => fetchEventlogs(true)} />
            </>
          );
        }}
        enableFilter
        hideSettings
        isLoading={isLoading}
        columns={[
          {
            id: "status",
            label: "Status (Click for details)",
            size: 300,
            enableResize: true,
            cell: ({ getValue, row }) => {
              const event = row.original;
              const value = getValue();
              return (
                <div
                  className={`flex items-center color-link cursor-pointer pr-2`}
                  style={{ fontFamily: "proxima-nova, sans-serif" }}
                  onClick={() => {
                    setEvent(event);
                    setIsModalVisible(true);
                  }}
                >
                  {value}
                  {value === "errored" ? <AlertCircle className="color-danger" size={16} /> : null}
                </div>
              );
            },
          },
          {
            id: "category",
            label: "Category",
            size: 150,
            enableResize: true,
          },
          {
            id: "contextText",
            label: "Context",
            size: 600,
            enableResize: true,
          },
          DateStringColumn({ id: "lastEventTimeProcessed" }, { label: "Last Event Time", format: formatStrings.log }),
          {
            id: "eventCount",
            label: "Event Count",
          },
        ]}
      />

      {nextLink ? (
        <Button
          className="mt-4 w-full"
          type="default"
          onClick={() => fetchEventlogs(false)}
          loading={isFetching}
          disabled={isFetching}
        >
          More events
        </Button>
      ) : null}

      {isModalVisible && (
        <ViewModal
          title={"Event"}
          object={event}
          onClose={() => setIsModalVisible(false)}
          visible={isModalVisible}
          filename={`event-${(event as any).id}`}
        />
      )}
    </>
  );
};
